import {Brick, Predicate, Query, registerBrick} from 'olympe';

/**
 * This brick fetches paginated application events with optional filters: event type(s), code, or creation date.
 * Returns results based on specified limit and offset for efficient data retrieval.
 */
export default class GetApplicationsEventsPaginated extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} eventType
     * @param {*} eventTypes
     * @param {string} eventCode
     * @param {*} createdAfter
     * @param {number} limit
     * @param {number} offset
     * @param {function()} forwardEvent
     * @param {function(*)} setEvents
     */
    async update($, [eventType, eventTypes, eventCode, createdAfter, limit, offset], [forwardEvent, setEvents]) {
        let query = Query.instancesOf('01998623077bea60b088');

        const predicates = [];
        if (eventType) {
            predicates.push(Predicate.equals('019986242270d430b85e', eventType));
        } else if (eventTypes && eventTypes.length > 0) {
            const typePredicates = eventTypes.map((type) =>
                Predicate.equals('019986242270d430b85e', type),
            );
            predicates.push(Predicate.or(...typePredicates));
        }
        if (eventCode) {
            predicates.push(Predicate.equals('01998623a02ac3de9cab', eventCode));
        }
        if (createdAfter) {
            const after =
                createdAfter instanceof Date ? createdAfter : new Date(createdAfter);

            predicates.push(
                Predicate.greaterThan('0199863214ee7ec5ef9a', after),
            );
        }
        if (predicates.length > 0) {
            const combined = predicates.reduce((acc, p) => acc ? Predicate.and(acc, p) : p, null);
            query = query.filter(combined);
        }

        query = query.limit(limit, offset);

        const results = await query.execute();
        setEvents(results);
        forwardEvent();
    }
}

registerBrick('019aa6097f217d6dcbf5', GetApplicationsEventsPaginated);
